import { Component, EventEmitter, Inject, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators, AbstractControl } from '@angular/forms';
import { Router } from '@angular/router';
import { MyErrorStateMatcher, CustomValidator } from 'src/app/services/validation';
import { AccountService } from '../account.service';

import { SnackbarService } from 'src/app/services/snackbar.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss']
})
export class ChangePasswordComponent implements OnInit {
  updateStatus = new EventEmitter();
  form!: FormGroup;
  strengthMsg: any;
  msgColor: any;
  username: string | null;
  matcher = new MyErrorStateMatcher();
  constructor(private accountService: AccountService, private router: Router, private fb: FormBuilder,
    public snackbarService: SnackbarService, @Inject(MAT_DIALOG_DATA) public data:any, public dialogRef: MatDialogRef<ChangePasswordComponent>) {
    // this.username = JSON.parse(sessionStorage?.getItem('username'));
    const user_data = sessionStorage.getItem('username');
    this.username = user_data ? JSON.parse(user_data) : null;
  }

  ngOnInit(): void {
    this.buildForm();
  }

  buildForm() {
    this.form = this.fb.group({
      oldPassword: ['', Validators.required],
      newPassword: ['', [Validators.required, CustomValidator.password]],
      confirmPassword: ['', Validators.required],
    }, { validator: this.passwordMatchValidator })
  }

  passwordConfirm(c: AbstractControl): { invalid: boolean } | null {
    if (c?.get('newPassword')?.value !== c?.get('confirmPassword')?.value) {
      return { invalid: true };
    }
    return null;
  }

  passwordMatchValidator(control: AbstractControl) {
    const password: string = control?.get('newPassword')?.value; // get password from our password form control
    const confirmPassword: string = control?.get('confirmPassword')?.value; // get password from our confirmPassword form control
    // compare is the password math
    if (password !== confirmPassword) {
      // if they don't match, set an error in our confirmPassword form control
      control?.get('confirmPassword')?.setErrors({ NoPassswordMatch: true });
    }
  }

  passwordstrength() {
    let pwd = this.form.value.newPassword
    if (pwd.length === 6) {
      this.strengthMsg = "Poor Password";
      this.msgColor = "Red";
    } else if (pwd.length >= 7 && pwd.length <= 9) {
      this.strengthMsg = "Weak Password";
      this.msgColor = "#800080";
    }
    else if (pwd.length >= 10 && pwd.length <= 12) {
      this.strengthMsg = "Average Password";
      this.msgColor = "#800080";
    }
    else if (pwd.length >= 13 && pwd.length <= 20) {
      this.strengthMsg = "Strong Password";
      this.msgColor = "green";
    }

  }

  public errorHandling(control: string, error: string) {
    return this.form.controls[control].hasError(error);
  }

  submit() {
    if (this.form.valid) {
      let req = {
        username: this.data.username,
        password: this.form?.get('oldPassword')?.value,
        newPassword: this.form.get('newPassword')?.value,
        confirmPassword: this.form.get('confirmPassword')?.value
      }
      this.accountService.initialchangePass(req).subscribe((data: any) => {
        this.openSnackbar(data['message']);
        this.dialogRef.close();
        this.router.navigate(['/auth/login']);
      }
        , error => {
          let message = error.error || error.error[0];
          this.openSnackbar(message.error);
        })
    }
  }

  /**
* open toaster for showing message 
*/
  openSnackbar(message: string) {
    this.snackbarService.open(message);
  }

}
